import React from 'react';
import {Card} from 'react-bootstrap';
import './frase.css'

const Frase = (props) => {
    return (
        <Card>
            <Card.Body>
                <div className="row">
                    <div className="col-sm-12 col-md-4">
                        <img src={props.personaje.image} alt={props.personaje.character}/>
                    </div>
                    <div className="col-sm-12 col-md-8">
                        <Card.Title className="nombrePJ">{props.personaje.character}</Card.Title>
                        <Card.Text className="frasePJ">
                        {props.personaje.quote}
                        </Card.Text>
                    </div>
                </div>
            </Card.Body>
        </Card>
    );
};

export default Frase;